import React, { useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../lib/constants';
import MainNavbar from './MainNavbar';
import Footer from './Footer';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title = 'Sign In', description = 'Access your account below.' }) => {
  // Removed unused username and setUsername

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Removed setUsername
      return;
    }
    axios.get(`${API_BASE_URL}/api/current-user/`)
      .then(() => {/* Removed setUsername */})
      .catch(() => {/* Removed setUsername */});
  }, []);

  return (
    <div style={{ width: '100vw', minHeight: '100vh', background: '#f7f7fa', position: 'relative', boxSizing: 'border-box', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <MainNavbar />
      <div style={{ width: '100%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: '32px 20px' }}>
        <div style={{ maxWidth: 400, width: '100%', background: '#fff', borderRadius: 12, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', padding: 32 }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>{title}</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>{description}</p>
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AuthLayout;
